/**
 * Lets shoppers switch the collection grid between the theme's configured
 * column count ("comfortable") and one column denser ("compact"), persisted
 * for the session so it survives pagination/filtering.
 */
(() => {
  const STORAGE_KEY = 'eyd:grid-density';

  function applyDensity(grid, density) {
    grid.classList.toggle('is-compact-grid', density === 'compact');
    grid.style.setProperty('--compact-columns', grid.dataset.compactColumns);
  }

  function syncButtons(toggle, density) {
    toggle.querySelectorAll('[data-grid-density]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.gridDensity === density);
      button.setAttribute('aria-pressed', button.dataset.gridDensity === density);
    });
  }

  function init(toggle) {
    const grid = toggle.parentElement.querySelector('#product-grid');
    if (!grid) return;

    const density = sessionStorage.getItem(STORAGE_KEY) || 'comfortable';
    applyDensity(grid, density);
    syncButtons(toggle, density);

    toggle.addEventListener('click', (event) => {
      const button = event.target.closest('[data-grid-density]');
      if (!button) return;
      const nextDensity = button.dataset.gridDensity;
      sessionStorage.setItem(STORAGE_KEY, nextDensity);
      applyDensity(grid, nextDensity);
      syncButtons(toggle, nextDensity);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.grid-density-toggle').forEach(init);
  });
})();
